import "./UpdateTickeClosed.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import newRequest from "../../context/newRequest";

const UpdateTicketClosed = ({ inputs, title }) => {
  const [ticketClosed, setTicketClosed] = useState({});
  const [ticketUpdateClosed, setTicketUpdateClosed] = useState({});
  const [categoryId, setCategoryId] = useState(false);
  const [statusId, setStatusId] = useState(false);
  const [sending, setSending] = useState("");
  const { ticketId } = useParams();
  const user = localStorage.getItem("user");
  const { data, loading, error } = useFetch(`/closed/${ticketId}`);
  const navigate = useNavigate();
  useEffect(() => {
    setTicketClosed(data);
  }, [data]);



  const handleSelectCategoryID = (e) => {
    const value = Array.from(
        e.target.selectedOptions,
        (option) => option.value
    );
    setCategoryId(value);
  };
  console.info(ticketClosed)
  const handleSelectStatusID = (e) => {
    const value = Array.from(
        e.target.selectedOptions,
        (option) => option.value
    );
    setStatusId(value);
  };


  const handleChange = (e) => {
    setTicketUpdateClosed((prev) => ({ ...prev, [e.target.id]: e.target.value }));
  };


  const handleClick = async (e) => {
    e.preventDefault();
    try {
        setSending("On Submit")
      const newTicketUpdate = {
        ...ticketUpdateClosed,
        category_id : categoryId[0],
        status_id : statusId[0]
      };

     const res= await newRequest.put(`/closed/${ticketId}`, newTicketUpdate, {
        // headers
        headers: {
          'Authorization': `$Bearer ${user.token}`
        },
      });
     setSending("Sending...")
      if (res.status == 200) {
        navigate(`/closed/${ticketId}`);
      }
      console.log(res.status)
    } catch (err) {
      setSending(err.response.data.errors)
      console.log(err);
    }
  };
  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <div className="right">
            <div className="detailItem">
              <span className="itemKey">Ticket ID:</span>
              <span className="itemValue">{ticketId}</span>
            </div>
            <form>

              <div className="formInput">
                {inputs.map((input) => (
                    <div className="formInput" key={input.id}>
                      <label>{input.label}</label>
                      <input type={input.type} placeholder={input.placeholder} onChange={handleChange} id={input.id}/>
                    </div>
                ))}
                  <button onClick={handleClick}>Send</button>
              </div>
            </form>
          </div>
        </div>
        {sending && <p className="error">{sending}</p>}
      </div>
    </div>
  );
};

export default UpdateTicketClosed;
